/**
 * Calculates straight amortization
 * @param amount
 * @param years
 * @param interest
 */
function calculateStraightAmortization ({ amount, years, interest } = {}) {
  if (!amount || !years || !interest) return

  const amortiseRate = amount / years / 12
  const costMonth1 = parseInt(((amount) * (interest / 1200) + amortiseRate))
  const costMonth2 = parseInt(((amount - amortiseRate) * (interest / 1200) + amortiseRate))
  const costMonth3 = parseInt(((amount - (amortiseRate) * 2) * (interest / 1200) + amortiseRate))
  const costLast = parseInt((((amount - (amortiseRate) * ((years * 12) - 1)) * (interest / 1200)) + amortiseRate))
  const costAverage = Math.round((costMonth1 + costLast) / 2)

  return {
    amortiseRate,
    costMonth1,
    costMonth2,
    costMonth3,
    costLast,
    costAverage
  }
}

module.exports = { calculateStraightAmortization }
